export const STATUS_CODES = {
  NO_CONTENT: 204,
  TIMEOUT: 408
};
